import React, { useEffect, useState } from 'react'

import _ from 'lodash'

import Modal from 'components/common/Modal'
import Input from 'components/common/Input'
import DataTypeIcon from 'components/common/DataTypeIcon'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'
import Text from 'components_new/atoms/Text'

import Styles from './styles.module.css'

const EditEndpoint = ({ endpoint, onClose, setAlert, resetAlert, onSave }) => {
  const [values, setValues] = useState({ slug: '', output_attributes: [] })
  const [slugLock, setSlugLock] = useState(true)
  const [attributeLocks, setAttributeLocks] = useState([])

  useEffect(() => {
    setValues({
      slug: endpoint?.slug,
      output_attributes:
        endpoint?.output_attributes?.map((attr) => ({
          id: attr.id,
          name: attr.attributes.name
        })) || []
    })

    if (endpoint?.output_attributes) {
      setAttributeLocks(
        _.range(endpoint.output_attributes.length).map(() => true)
      )
    }

    setSlugLock(true)
  }, [endpoint])

  return (
    <Modal
      header={'Redigera objekt'}
      visible={!!endpoint}
      onClose={() => onClose()}
      actions={
        <>
          <Button onClick={() => onClose()} variant="text">
            Avbryt
          </Button>
          <Button
            onClick={() => {
              onSave(values)
              onClose()
            }}
          >
            Spara
          </Button>
        </>
      }
    >
      <Input
        label={'Slug'}
        withLock
        lockStyle={Styles.lock}
        locked={slugLock}
        setLocked={() =>
          setAlert({
            header: 'Redigera slug',
            content: (
              <Text variant="body1">
                Att redigera slug för detta objekt påverkar direkt alla parter
                som för närvarande använder ditt API. Det kan orsaka problem.
              </Text>
            ),
            onCancel: () => resetAlert(),
            onOk: () => {
              setSlugLock(false)
              resetAlert()
            },
            cancelText: 'Avbryt',
            okText: 'Lås upp'
          })
        }
        size="large"
        value={values.slug}
        onChange={(e) => setValues({ ...values, slug: e })}
      />

      <Box>
        <Box
          sx={{
            bgcolor: 'grey.100',
            p: 2,
            mb: 1
          }}
        >
          {values.output_attributes.map(({ name }) => {
            const outputAttribute = endpoint?.output_attributes.find(
              (oa) => oa.attributes.name === name
            )

            const mappedAttribute = endpoint?.mapped_output_attributes.find(
              (ma) => ma.output_attribute_id === outputAttribute.id
            )

            return (
              <Box key={`attribute-field-${name}`} sx={{ display: 'flex' }}>
                <Box
                  sx={{
                    width: '200px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                  }}
                >
                  <DataTypeIcon type={outputAttribute?.attributes.type} />
                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <small className={'secondary tiny'}>
                      {mappedAttribute?.origin_table_name}
                    </small>
                    <small>
                      {mappedAttribute?.origin_output_attribute_name}
                    </small>
                  </Box>
                </Box>

                <Box sx={{ flex: 1 }}>
                  <Input
                    size={'large'}
                    value={name}
                    onChange={(e) => {
                      const newAttributes = values.output_attributes.map(
                        (attr) =>
                          attr.name === name ? { ...attr, name: e } : attr
                      )

                      setValues({
                        ...values,
                        output_attributes: newAttributes
                      })
                    }}
                    withLock
                    lockStyle={Styles.lock}
                    locked={attributeLocks[name]}
                    setLocked={() =>
                      setAlert({
                        header: 'Redigera attribut ID',
                        content: (
                          <Text variant="body1">
                            Att redigera ID:t för detta attribut påverkar direkt
                            alla parter som för närvarande använder ditt API.
                            Det kan orsaka problem.
                          </Text>
                        ),
                        onCancel: () => resetAlert(),
                        onOk: () => {
                          const tmpLocks = _.cloneDeep(attributeLocks)

                          tmpLocks[name] = false

                          setAttributeLocks(tmpLocks)
                          resetAlert()
                        },
                        cancelText: 'Avbryt',
                        okText: 'Lås upp'
                      })
                    }
                  />
                </Box>
              </Box>
            )
          })}
        </Box>
      </Box>
    </Modal>
  )
}

export default EditEndpoint
